import React from 'react';
import { ToastContainer } from 'react-toastify';
import Navbar from '../components/PartnerPage/Navbar';
import HeroSection from '../components/PartnerPage/PortrushDreamgetaway/HeroSection';
import BenefitsSection from '../components/PartnerPage/PortrushDreamgetaway/BenefitsSection';
import SpecialOfferDescription from '../components/PartnerPage/SpecialOfferDescription';
import Footer from '../components/PartnerPage/Footer';
import OurServiceSection from '../components/PartnerPage/PortrushDreamgetaway/OurServiceSection';
import { EmailInputProvider } from '../contexts/EmailInputContext';
import HelpIcon from 'images/help-icon.png';
import ShipPlayClearLogo from 'images/ship-play-clear-logo.png';
import NavLogo from 'images/shipsticks-logo.png';
import BenefitsVisual from 'images/portrush/portrush_benefits.jpg';

export default function PortrushDreamgetawayPage() {
  const benefits = [
    'One round of golf at Royal Portrush, Royal County Down, Portmarnock, Castlerock, Ballyliffin, and Portstewart',
    'Airfare to and from Ireland (or equivalent value) and transportation to and from all courses',
    'Deluxe accommodations',
    '$500 Sugarloaf Social Club gift card',
    'Round-trip shipping with ShipSticks'
  ];

  return (
    <>
      <EmailInputProvider>
        <ToastContainer />
        {/* Background image container with responsive height */}
        <div className="relative font-poppins 
        bg-cover bg-center backgroundImage 
        h-full bg-no-repeat">
          <Navbar NavLogo={NavLogo} logoClasses="w-32 sm:w-32 md:w-40 lg:w-32 max-w-40" showExtraLinks={false} customCTAPath="/ship"/>
          <HeroSection
            heading={
              <>
                Win a Dream Golf Trip to Ireland

              </>
            }
            subheading={
              <>
                You, a friend, and 6 iconic golf courses.
                Enter your email below for a chance to win
                the golf trip of a lifetime.
              </>
            }
          />
        </div>

        <main className="flex flex-col items-center justify-between w-full font-poppins">
          <OurServiceSection />
          <BenefitsSection
            title="Valued at more than $20,000, each grand prize includes:"
            benefits={benefits}
            src={BenefitsVisual}
          />
        </main>
      </EmailInputProvider>
      <Footer FooterLogo={NavLogo} logoSize="w-32" brand="shipsticks" shipLinkPath="/ship">
        {/* Privacy Statement */}
        <div className="
          flex flex-col gap-4 lg:gap-0 lg:flex-row items-center
          justify-center sm:space-x-4 text-center pb-9
        ">
          <img
            src={HelpIcon}
            alt="Life Vest Icon"
            className="h-20 w-20"
          />
          <p className="mb-2 text-xl font-semibold sm:pl-3 pt-2">
            Your information is safe with us. We respect your privacy and protect your data.
          </p>
        </div>

        {/* Contact Section */}
        <div className="text-left py-8 border-t border-[#FFF] border-opacity-20 pl-[5%] lg:pl-0">
          <h5 className="text-white text-xl font-semibold mb-2">Have questions?</h5>
          <p className="mb-2 text-lg leading-8">
            Our friendly support team is here to help! Contact us at&nbsp;
            <a
              href="mailto:customersupport@shipsticks.com"
              className="text-[#49C44F] hover:text-[#6ad687] underline break-words"
            >
              customersupport@shipsticks.com
            </a>
            &nbsp;or call&nbsp;
            <a className="text-[#49C44F] hover:text-[#6ad687] underline" href="tel:8557927529">(855) 792-7529</a>.
          </p>
        </div>
      </Footer>
    </>
  );
}
